import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isOpen: false,
    case: undefined,
    product_id: undefined,
}

export const contactFormModalSlice = createSlice({
    name: 'contactFormModal',
    initialState: initialState,
    reducers: {
        open: (state, action) => {
            state.isOpen = true
            if (action.payload !== undefined)
            {
                if(action.payload.case !== undefined)
                {
                    state.case = action.payload.case
                }
                if (action.payload.product_id !== undefined)
                {
                    state.product_id = action.payload.product_id
                }
            }
        },
        close: state => {
            for (const i in initialState)
            {
                state[i] = initialState[i]
            }
        },
    },
})

export const { open, close } = contactFormModalSlice.actions
export default contactFormModalSlice.reducer
